"use client"

import { FileXCorner } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FileXCornerIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FileXCornerIcon = component(Icon)({ as: FileXCorner })
